import { LegalLayout, LegalSection } from "../components/LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout
      title="Impressum"
      subtitle="Angaben gemäss den gesetzlichen Anforderungen der Schweiz."
    >
      <LegalSection heading="Verantwortlich für den Inhalt">
        <p>
          <strong>Urban Beauty Klosters</strong>
          <br />
          Inhaberin: Alexandra Urban
          <br />
          Landstrasse 206
          <br />
          7250 Klosters
          <br />
          Schweiz
        </p>
      </LegalSection>

      <LegalSection heading="Kontakt">
        <p>
          Telefon: 076 216 78 00
          <br />
          E-Mail: urban_ale_2007@yahoo.com
        </p>
      </LegalSection>

      <LegalSection heading="Handelsregister">
        <p>
          Unternehmens-Identifikationsnummer (UID): CHE-403.065.297
        </p>
      </LegalSection>

      <LegalSection heading="Haftungsausschluss">
        <p>
          Die Autorin übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen
          Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und
          Vollständigkeit der Informationen. Haftungsansprüche gegen die
          Autorin wegen Schäden materieller oder immaterieller Art, welche aus
          dem Zugriff oder der Nutzung bzw. Nichtnutzung der veröffentlichten
          Informationen, durch Missbrauch der Verbindung oder durch technische
          Störungen entstanden sind, werden ausgeschlossen.
        </p>
      </LegalSection>

      <LegalSection heading="Haftung für Links">
        <p>
          Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres
          Verantwortungsbereichs. Es wird jegliche Verantwortung für solche
          Webseiten abgelehnt. Der Zugriff und die Nutzung solcher Webseiten
          erfolgen auf eigene Gefahr des jeweiligen Nutzers.
        </p>
      </LegalSection>

      <LegalSection heading="Urheberrechte">
        <p>
          Die Urheber- und alle anderen Rechte an den redaktionellen Inhalten,
          Texten und eigenen Fotos auf dieser Website gehören Urban Beauty
          Klosters oder den jeweils genannten Rechtsinhabern. Abgebildete
          Produkte sowie die dazugehörigen Produktbilder sind Eigentum der
          jeweiligen Hersteller; Produktbilder © FUTURACONTOUR® und werden mit
          freundlicher Genehmigung im Rahmen des autorisierten Verkaufs
          verwendet. Für die Reproduktion jeglicher Elemente ist die
          schriftliche Zustimmung der jeweiligen Rechtsinhaber im Voraus
          einzuholen.
        </p>
      </LegalSection>

    </LegalLayout>
  );
}
